import { render, staticRenderFns } from "./CarDealership.vue?vue&type=template&id=9c620a80&"
import script from "./CarDealership.vue?vue&type=script&lang=ts&"
export * from "./CarDealership.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports